import { useRef } from "react";
import {
  CultivarSectionRefHandles,
  CultivarSectionRefs,
  SaveDocumentDataHandle
} from "../types/cultivarForm.types";

export const useCultivarSectionRefs = () => {
  const cultivationRef = useRef<CultivarSectionRefHandles>(null);
  const fieldRef = useRef<CultivarSectionRefHandles>(null);
  const fertilizerRef = useRef<CultivarSectionRefHandles>(null);
  const pesticideRef = useRef<CultivarSectionRefHandles>(null);
  const irrigationRef = useRef<CultivarSectionRefHandles>(null);
  const fuelUseRef = useRef<CultivarSectionRefHandles>(null);
  const landUseRef = useRef<CultivarSectionRefHandles>(null);
  const notesRef = useRef<SaveDocumentDataHandle>(null);

  const sectionRefs: CultivarSectionRefs = {
    cultivation: cultivationRef,
    field: fieldRef,
    fertilizer: fertilizerRef,
    pesticide: pesticideRef,
    irrigation: irrigationRef,
    fuelUse: fuelUseRef,
    landUse: landUseRef
  };

  return {
    sectionRefs,
    cultivationRef,
    fieldRef,
    fertilizerRef,
    pesticideRef,
    irrigationRef,
    fuelUseRef,
    landUseRef,
    notesRef
  };
};
